import React, { useEffect } from 'react'
import {
  deleteConquestAd,
  fetchConquestAds,
} from 'actions/views/shops'
import useAction from 'utils/useAction'
import {
  getCurrentShopId,
  getIsConquestAdsLoaded,
  getConquestAds,
  getConquestAdsFilters,
  getConquestAdsPage,
  getConquestAdsPageCount,
  getConquestAdsSorter,
  getIsSavingActive,
  getIsConquestAdsDataFilteredOrSorted,
} from 'domains/shops/selectors'
import { useSelector } from 'react-redux'
import { Button, Spin } from 'antd'
import { Buttons, StyledTable } from '../Shops.styles'
import { getRegularRowClass, getRowKey } from 'helpers/tables'
import getColumns from './conquestAdsColumns'
import { openConfirmModal, openConquestAdModal, openShopOffersModal } from 'reducers/modals/actions'
import { setShopOfferForEdit } from 'domains/shops/actions'
import { FIELD_NAMES } from 'const/forms'
import { PAGE_SIZE } from '../../../const/tables'

const ConquestAdsTab = () => {
  const currentShopId = useSelector(getCurrentShopId)
  const conquestAds = useSelector(getConquestAds)
  const pageCount = useSelector(getConquestAdsPageCount)
  const filters = useSelector(getConquestAdsFilters)
  const sorter = useSelector(getConquestAdsSorter)
  const page = useSelector(getConquestAdsPage)
  const isLoaded = useSelector(getIsConquestAdsLoaded)
  const isSavingActive = useSelector(getIsSavingActive)

  const fetchConquestAdsFunc = useAction(fetchConquestAds)
  const openConquestAdModalFunc = useAction(openConquestAdModal)
  const deleteConquestAdFunc = useAction(deleteConquestAd)
  const openConfirmModalFunc = useAction(openConfirmModal)
  const openShopOffersModalFunc = useAction(openShopOffersModal)
  const setShopOfferForEditFunc = useAction(setShopOfferForEdit)

  const isDataFilteredOrSorted = useSelector(
    getIsConquestAdsDataFilteredOrSorted
  )

  const paginationConfig = {
    position: ['bottomCenter'],
    showQuickJumper: true,
    total: pageCount * PAGE_SIZE,
    pageSize: PAGE_SIZE,
    current: page,
    showSizeChanger: false,
  }

  const handleResetFilters = () => {
    fetchConquestAdsFunc({
      filters: {},
      sorter: {},
      page: 1,
    })
  }

  const handleDeleteConquestAd = (ad) => {
    const callback = () => deleteConquestAdFunc(ad[FIELD_NAMES.id])
    const text =
      `Are you sure you want to delete conquest ad (ID: ${
        ad[FIELD_NAMES.id]
      })? ` + "This action can't be revoked."
    openConfirmModalFunc({ callback, text })
  }

  const onTableChange = (pagination, filters, sorter) => {
    fetchConquestAdsFunc({
      page: pagination.current,
      filters,
      sorter,
    })
  }

  const handleEditAd = (id) => {
    openConquestAdModalFunc({ id })
  }

  const handleEditShopOffer = (ad) => {
    const shopOfferData = ad.attributes?.shop_offer_data
    if (shopOfferData) {
      setShopOfferForEditFunc(shopOfferData)
      openShopOffersModalFunc({ id: ad.attributes.shop_offer_id })
    }
  }

  const handleCreateAd = () => {
    openConquestAdModalFunc()
  }

  useEffect(() => {
    if (currentShopId) fetchConquestAdsFunc()
  }, [currentShopId])

  return (
    <Spin spinning={isSavingActive} size="large">
      <Buttons>
        <Button
          onClick={handleResetFilters}
          disabled={!isLoaded || !isDataFilteredOrSorted}
          style={{ marginLeft: '12px' }}
        >
          Reset filters
        </Button>

        <Button
          onClick={handleCreateAd}
          disabled={!currentShopId}
          style={{ marginRight: '12px' }}
        >
          Create conquest ad
        </Button>
      </Buttons>

      <StyledTable
        onChange={onTableChange}
        dataSource={conquestAds}
        columns={getColumns(
          filters,
          sorter,
          handleEditAd,
          handleDeleteConquestAd,
          handleEditShopOffer
        )}
        size="medium"
        pagination={paginationConfig}
        rowKey={getRowKey}
        rowClassName={getRegularRowClass}
        bordered
        sticky={isLoaded}
        scroll={{ x: 'max-content' }}
      />
    </Spin>
  )
}

export default ConquestAdsTab
